var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 70,
    viewBox: "0 0 56 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_48_1753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.65243C0 1.63525 1.63525 0 3.65243 0H52.3476C54.3647 0 56 1.63525 56 3.65243V66.3476C56 68.3648 54.3647 70 52.3476 70H3.65243C1.63525 70 0 68.3648 0 66.3476V3.65243Z",
    fill: "#AD4123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3496 39H10.498V30.4336H15.3496V31.6172H11.9043V33.9434H15.1328V35.1211H11.9043V37.8105H15.3496V39ZM24.3496 39H22.6211L18.4258 32.1621H18.373C18.3887 32.3926 18.4023 32.6367 18.4141 32.8945C18.4297 33.1523 18.4414 33.418 18.4492 33.6914C18.4609 33.9648 18.4707 34.2422 18.4785 34.5234V39H17.2012V30.4336H18.918L23.1074 37.2246H23.1484C23.1406 37.0254 23.1309 36.7969 23.1191 36.5391C23.1074 36.2812 23.0957 36.0156 23.084 35.7422C23.0762 35.4648 23.0703 35.1973 23.0664 34.9395V30.4336H24.3496V39ZM29.5703 39H28.1582V31.6289H25.6504V30.4336H32.0723V31.6289H29.5703V39ZM38.2363 39H33.3848V30.4336H38.2363V31.6172H34.791V33.9434H38.0195V35.1211H34.791V37.8105H38.2363V39ZM42.4961 30.4336C43.2344 30.4336 43.8438 30.5234 44.3242 30.7031C44.8086 30.8828 45.168 31.1562 45.4023 31.5234C45.6406 31.8906 45.7598 32.3574 45.7598 32.9238C45.7598 33.3457 45.6816 33.7051 45.5254 34.002C45.3691 34.2988 45.1641 34.5449 44.9102 34.7402C44.6562 34.9355 44.3848 35.0918 44.0957 35.209L46.5273 39H44.9395L42.8711 35.5664H41.4941V39H40.0879V30.4336H42.4961ZM42.4023 31.6055H41.4941V34.4062H42.4668C43.1191 34.4062 43.5918 34.2852 43.8848 34.043C44.1816 33.8008 44.3301 33.4434 44.3301 32.9707C44.3301 32.4746 44.1719 32.123 43.8555 31.916C43.543 31.709 43.0586 31.6055 42.4023 31.6055Z",
    fill: "#F4D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65243 2H52.3476V-2H3.65243V2ZM54 3.65243V66.3476H58V3.65243H54ZM52.3476 68H3.65243V72H52.3476V68ZM2 66.3476V3.65243H-2V66.3476H2ZM3.65243 68C2.73982 68 2 67.2602 2 66.3476H-2C-2 69.4693 0.530679 72 3.65243 72V68ZM54 66.3476C54 67.2602 53.2602 68 52.3476 68V72C55.4693 72 58 69.4693 58 66.3476H54ZM52.3476 2C53.2602 2 54 2.73982 54 3.65243H58C58 0.530679 55.4693 -2 52.3476 -2V2ZM3.65243 -2C0.53068 -2 -2 0.530676 -2 3.65243H2C2 2.73982 2.73982 2 3.65243 2V-2Z",
    fill: "#AB7F39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_48_1753",
    x: -4,
    y: -4,
    width: 64,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_48_1753"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_48_1753",
    result: "effect2_innerShadow_48_1753"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.21299d71ebb5740b76037e1ea55a8f3a.svg";
export { ForwardRef as ReactComponent };